<template>
  <b-modal
    :visible="visible"
    centered
    hide-header
    hide-footer
    scrollable
    dialog-class="modal-color-black upload-company-file-dialog"
    @hide="onDialogHide"
  >
    <div
      :class="['file-input-dropzone', { highlighted: highlighted > 0 }]"
      @dragover="onDragOver"
      @dragenter="onDragEnter"
      @dragleave="onDragLeave"
      @drop="onDrop"
    >
      <input
        ref="file"
        id="file"
        type="file"
        name="file"
        accept=".pdf,.jpg,.jpeg,.png,.webp"
        class="file-input"
        @change="onFileChange"
      />

      <label for="file" class="file-input-label">
        <div class="file-input-content">
          <div class="file-input-name-container">
            <b-icon-cloud-upload font-scale="4" :class="['file-input-icon', { 'mr-2': !!file }]" />
            <span v-if="!!file" class="file-input-name ml-2">{{ file.name }}</span>
          </div>

          <div>{{ $t('Drag and drop file here') }}</div>

          <div>{{ $t('or') }}</div>

          <div class="upload-company-file-actions">
            <b-spinner v-if="processing" variant="primary" />

            <b-button
              :disabled="processing"
              pill
              size="sm"
              variant="secondary"
              class="text-uppercase mr-2"
              @click.stop.prevent="onCancelClick"
            >
              <span>{{ $t('confirm-cancel') }}</span>
            </b-button>

            <b-button
              tag="span"
              :disabled="processing"
              pill
              size="sm"
              variant="primary"
              :class="['text-uppercase', { 'ml-2': !file, 'mx-2': !!file }]"
            >
              <span>{{ $t('Select file') }}</span>
            </b-button>

            <b-button
              v-if="file"
              :disabled="processing || !file"
              pill
              size="sm"
              variant="primary"
              class="text-uppercase ml-2"
              @click.stop.prevent="onConfirmClick"
            >
              <span>{{ $t('Confirm') }}</span>
            </b-button>
          </div>
        </div>
      </label>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'UploadProjectFileDialog',

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      file: null,
      fileData: null,
      highlighted: 0,
      processing: false,
    };
  },

  methods: {
    onFileChange() {
      this.fileData = null;
      this.file = null;
      const file = this.$refs.file && this.$refs.file.files && this.$refs.file.files[0];
      if (!file) {
        return;
      }

      this.processing = true;
      const reader = new FileReader();
      reader.onload = (event) => {
        this.fileData = event.target.result;
        this.file = file;
        this.processing = false;
      };
      reader.onerror = () => {
        this.processing = false;
      };
      reader.readAsArrayBuffer(file);
    },

    onDragOver(event) {
      event.preventDefault();
    },

    onDragEnter(event) {
      event.preventDefault();
      this.highlighted++;
    },

    onDragLeave() {
      this.highlighted--;
    },

    onDrop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onFileChange();
      this.highlighted = 0;
    },

    onDialogHide(event) {
      if (this.processing) {
        event.preventDefault();
      } else {
        this.$emit('close');
      }
    },

    onConfirmClick() {
      this.$emit('confirm', this.file, this.fileData);
    },

    onCancelClick() {
      if (!this.processing) {
        this.$emit('cancel');
      }
    },
  },
};
</script>

<style>
.upload-company-file-dialog .modal-body {
  padding: 8px;
}
</style>

<style scoped>
.upload-company-file-actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.upload-company-file-actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.file-input-dropzone {
  position: relative;
  width: 100%;
  min-height: 300px;
}

.file-input {
  opacity: 0;
  position: absolute;
  z-index: -1;
}

.file-input-label {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.file-input-content {
  width: 100%;
  height: 100%;
  border: 1px dashed var(--bs-gray-500);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  padding: 32px 0;
}

.file-input-dropzone.highlighted .file-input-content {
  background: var(--bs-teal);
  border: 1px dashed var(--bs-success);
}

.file-input-name-container {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  overflow: hidden;
  flex-wrap: nowrap;
  white-space: nowrap;
  padding: 0 32px;
}

.file-input-icon {
  color: var(--bs-primary);
}

.file-input-name {
  font-size: 2rem;
  color: var(--bs-primary);
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/organisation/EditCompany/CompanyFiles/ProjectFiles/UploadProjectFileDialog.vue